import { render, staticRenderFns } from "./OpenEndedQuestion.vue?vue&type=template&id=6c128dca&scoped=true&"
import script from "./OpenEndedQuestion.vue?vue&type=script&lang=js&"
export * from "./OpenEndedQuestion.vue?vue&type=script&lang=js&"
import style0 from "./OpenEndedQuestion.vue?vue&type=style&index=0&id=6c128dca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c128dca",
  null
  
)

export default component.exports